import { toRefs, computed, provide } from 'vue';
import { useModel } from '../../compositions/component-lib.esm15.js';
import { convertToUnit } from '../../utils/component-lib.esm6.js';

//
var script = {
  props: {
    size: {
      type: [String, Number],
      default: '3rem'
    },
    value: {
      type: String,
      default: null
    }
  },
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const {
      size,
      value
    } = toRefs(props);
    const localValue = useModel(value, val => emit('input', val));
    const styles = computed(() => {
      const sizeWithUnit = convertToUnit(size.value);
      return {
        '--c-size': sizeWithUnit
      };
    });
    provide('pickerOptions', {
      selectedColor: localValue,
      size: size,
      isInGroup: true,
      onSelect(color) {
        localValue.value = color;
      }
    });
    return {
      styles
    };
  }
};
export { script as default };